import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useLanguage } from '../i18n';
import logo from '../assets/logo.jpg';

export default function Login() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const { language, toggleLanguage, t } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [user, navigate]);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    const result = await login(email, password);
    if (result.error) {
      setError(result.error.message);
      setSubmitting(false);
    } else {
      navigate('/admin/dashboard', { replace: true });
    }
  }

  return <main className="login-page"><form className="login-card" onSubmit={submit}>
    <div className="brand-block login-brand"><img className="brand-logo" src={logo} alt="SIAEDTS logo" /><span>SIAEDTS Admin</span></div>
    <button type="button" className="language-toggle login-language-toggle" onClick={toggleLanguage} aria-label={t('language')}>{language === 'en' ? 'FR' : 'EN'}</button>
    <p className="eyebrow">{t('staffWorkspace')}</p><h1>{t('signIn')}</h1>
    <label>{t('email')}<input type="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></label>
    <label>{t('password')}<input type="password" required value={password} onChange={(event) => setPassword(event.target.value)} /></label>
    {error && <p className="form-error">{error}</p>}
    <button className="primary-button" type="submit" disabled={submitting}>{submitting ? t('signingIn') : t('signIn')}</button>
  </form></main>;
}
